import { Icon, ICONS_ENUM, Typography } from '@sanlam-glacier/app-common/components';
import { PropsWithChildren } from 'react';
import contentStyles from './content.module.scss';

type DevToolsContentProps = {
  title: string;
  onCloseClick?: () => void;
};

export const DevToolsContent = ({
  title,
  onCloseClick,
  children
}: PropsWithChildren<DevToolsContentProps>) => {
  return (
    <div className={contentStyles.menuContent}>
      <div className={contentStyles.menuContentHeader}>
        <Typography color={Typography.COLOR.INHERIT} variant={Typography.VARIANT.H3}>
          {title}
        </Typography>
        {onCloseClick && (
          <Icon
            className={contentStyles.menuContentClose}
            icon={ICONS_ENUM.NAVIGATION_CLOSE}
            title='Close'
            onClick={onCloseClick}
          />
        )}
      </div>
      {children}
    </div>
  );
};
